<template>
  <div class="exam-tempalte-app">
    <div class="exam-tempalte-scorll" :style="{ padding: $route.query.type ? '0px 24px 24px 24px' : '24px' }">
      <div v-if="$route.query.type" class="header-title">
        <span class="bor" />
        {{ title }}</div>
      <div class="exam-tempalte-header">
        <div class="header-type">{{ headerType }}<span class="setm-title">【共{{ activeTitle.numTotal }}题；合计{{ activeTitle.scoreTotal }}分】</span></div>
        <div class="header-number"><span>{{ progress.current }}</span>/{{ progress.total }}</div>
      </div>
      <div class="exam-tempalte-content">
        <div>
          <!-- 单选 -->
          <div v-if="topic.type === 1||topic.type === 11||topic.type === 12||topic.type === 17||topic.type === 22" class="single-questions">
            <!-- <div class="setm" v-html="activeTitle.title" /> -->
            <div class="setm">
              {{ exams.map(val => val.id).indexOf(activeTitle.id)+1+'、' }}
              <span class="setm-title"><span class="setm-tips">{{ headerType }}</span>（{{ activeTitle.score }}分）</span>
              <span class="set-html" v-html="activeTitle.title" />
            </div>
            <AudioCompontent v-if="activeTitle.stem_audio" :vid="activeTitle.stem_audio.vid" :auto-play="true" />
            <div style="display: flex;margin-top:12px">
              <VideoComponent v-if="activeTitle.stem_video" :vid="activeTitle.stem_video.vid" :video-poster-src="activeTitle.stem_video.thumb" />
              <el-image
                v-if="activeTitle.title_img"
                :src="activeTitle.title_img"
                class="title_img"
                :preview-src-list="[activeTitle.title_img]"
                style="margin-top: 0;"
              />
            </div>
            <div class="options" :class="$route.query.type?'showDis':''">
              <el-radio-group v-model="activeTitle.value" :disabled="$route.query.type||(examDetailed.answer_rule==2&&activeTitle.value&&activeTitle.nextCheck)?true:false">
                <el-row
                  v-for="(item,i) in activeTitle.option"
                  :key="i"
                  :class="{ selected: activeTitle.value == item.key&&!$route.query.type,selected2: (activeTitle.value == item.key&&activeTitle.is_right==1&&$route.query.type)||(activeTitle.answer===item.key&&$route.query.type),selected3:activeTitle.value == item.key&&activeTitle.is_right==0 &&$route.query.type}"
                >
                  <el-radio :label="item.key">
                    <div class="titls_content">
                      <img v-if="activeTitle.value == item.key&&activeTitle.is_right==1&&$route.query.type" src="@/assets/img/right.png" class="check_img">
                      <img v-if="activeTitle.value == item.key&&activeTitle.is_right==0&&$route.query.type" src="@/assets/img/wrong.png" class="check_img">
                      <span>{{ item.new_key }}.</span>
                      <span class="span" v-html="item.title" />
                    </div>
                    <div>
                      <el-image
                        v-if="item.img"
                        :src="item.img"
                        class="title_img_small"
                        :preview-src-list="[item.img]"
                      />
                    </div>
                  </el-radio>
                </el-row>
              </el-radio-group>
            </div>
          </div>
          <!-- B型题 -->
          <div v-else-if="topic.type === 16" class="a3-questions">
            <div class="setm">
              {{ exams.map(val => val.id).indexOf(activeTitle.id)+1+'、' }}
              <span class="setm-title">
                <span class="setm-tips">{{ headerType }}</span>
                <span v-if="topic.groupLength>1">({{ getNum }}题共用选项)</span>
                （{{ activeTitle.score }}分）</span>
              <span class="set-html" v-html="activeTitle.title" />
            </div>
            <AudioCompontent v-if="activeTitle.stem_audio" :vid="activeTitle.stem_audio.vid" :auto-play="true" />
            <div style="display: flex;margin-top:12px">
              <VideoComponent v-if="activeTitle.stem_video" :vid="activeTitle.stem_video.vid" :video-poster-src="activeTitle.stem_video.thumb" />
              <el-image
                v-if="activeTitle.title_img"
                :src="activeTitle.title_img"
                class="title_img"
                :preview-src-list="[activeTitle.title_img]"
                style="margin-top: 0;"
              />
            </div>
            <div class="options" :class="$route.query.type?'showDis':''">
              <el-radio-group v-model="activeTitle.value" :disabled="$route.query.type||(examDetailed.answer_rule==2&&activeTitle.value&&activeTitle.nextCheck)?true:false">
                <el-row
                  v-for="(item,i) in activeTitle.option"
                  :key="i"
                  :class="{ selected: activeTitle.value == item.key&&!$route.query.type,selected2: (activeTitle.value == item.key&&activeTitle.is_right==1&&$route.query.type)||(activeTitle.answer===item.key&&$route.query.type),selected3:activeTitle.value == item.key&&activeTitle.is_right==0 &&$route.query.type}"
                >
                  <el-radio :label="item.key">
                    <div class="titls_content">
                      <img v-if="activeTitle.value == item.key&&activeTitle.is_right==1&&$route.query.type" src="@/assets/img/right.png" class="check_img">
                      <img v-if="activeTitle.value == item.key&&activeTitle.is_right==0&&$route.query.type" src="@/assets/img/wrong.png" class="check_img">
                      <span>{{ item.new_key }}.</span>
                      <span class="span" v-html="item.title" />
                    </div>
                    <div>
                      <el-image
                        v-if="item.img"
                        :src="item.img"
                        class="title_img_small"
                        :preview-src-list="[item.img]"
                      />
                    </div>
                  </el-radio>
                </el-row>
              </el-radio-group>
            </div>
          </div>
          <!-- 多选 -->
          <div v-else-if="topic.type === 2||topic.type === 18||topic.type === 19" class="multiple-questions">
            <!-- <div class="setm" v-html="activeTitle.title" /> -->
            <div class="setm">
              {{ exams.map(val => val.id).indexOf(activeTitle.id)+1+'、' }}
              <span class="setm-title"><span class="setm-tips">{{ headerType }}</span>（{{ activeTitle.score }}分<span v-if="topic.type === 18">，可多选</span>）</span>
              <span class="set-html" v-html="activeTitle.title" />
            </div>
            <AudioCompontent v-if="activeTitle.stem_audio" :vid="activeTitle.stem_audio.vid" :auto-play="true" />
            <div style="display: flex;margin-top:12px">
              <VideoComponent v-if="activeTitle.stem_video" :vid="activeTitle.stem_video.vid" :video-poster-src="activeTitle.stem_video.thumb" />
              <el-image
                v-if="activeTitle.title_img"
                :src="activeTitle.title_img"
                class="title_img"
                :preview-src-list="[activeTitle.title_img]"
                style="margin-top: 0;"
              />
            </div>
            <div class="options " :class="$route.query.type?'showDis':''">
              <el-checkbox-group v-model="activeTitle.value">
                <el-row
                  v-for="(item,o) in activeTitle.option"
                  :key="o"
                  :class="{ selected:(activeTitle.value.indexOf(item.key)!== -1)&&!$route.query.type,
                            selected2:(activeTitle.value.indexOf(item.key)!== -1&&$route.query.type)||(activeTitle.answer.split('').indexOf(item.key)!== -1&&$route.query.type),
                            selected3:(activeTitle.value.indexOf(item.key)!== -1&&$route.query.type)&&(activeTitle.answer.split('').indexOf(item.key)== -1&&$route.query.type)
                  }"
                >
                  <el-checkbox :label="item.key" :disabled="$route.query.type||(examDetailed.answer_rule==2&&activeTitle.value&&activeTitle.nextCheck)?true:false">
                    <div class="titls_content">
                      <img v-if="activeTitle.value.indexOf(item.key)!== -1&&activeTitle.answer.split('').indexOf(item.key)!== -1&&$route.query.type" src="@/assets/img/right.png" class="check_img">
                      <img v-if="activeTitle.value.indexOf(item.key)!== -1&&activeTitle.answer.split('').indexOf(item.key)== -1&&$route.query.type" src="@/assets/img/wrong.png" class="check_img">
                      <span>{{ item.new_key }}.</span>
                      <span class="span" v-html="item.title" /></div>
                    <div>
                      <el-image
                        v-if="item.img"
                        :src="item.img"
                        class="title_img_small"
                        :preview-src-list="[item.img]"
                      />
                    </div>
                  </el-checkbox>

                </el-row>
              </el-checkbox-group>
            </div>
          </div>
          <!-- A3/A4 -->
          <div v-else-if="topic.type === 15" class="a3-questions">
            <div v-if="activeTitle.public_number" class="setm" style="margin-bottom:24px">
              <span class="setm-title">主题干：（<span v-if="topic.groupLength>1">{{ getNum }}题共用题干；</span>{{ activeTitle.groupScore }}分）:</span>
              <span class="set-html" v-html="activeTitle.public_title" />
            </div>
            <el-image
              v-if="activeTitle.public_title_img"
              :src="activeTitle.public_title_img"
              class="title_img"
              :preview-src-list="[activeTitle.public_title_img]"
            />
            <div class="setm">
              {{ exams.map(val => val.id).indexOf(activeTitle.id)+1+'、' }}
              <span class="setm-title"><span class="setm-tips">{{ headerType }}</span>（{{ activeTitle.score }}分）</span>
              <span class="set-html" v-html="activeTitle.title" />
            </div>
            <AudioCompontent v-if="activeTitle.stem_audio" :vid="activeTitle.stem_audio.vid" :auto-play="true" />
            <div style="display: flex;margin-top:12px">
              <VideoComponent v-if="activeTitle.stem_video" :vid="activeTitle.stem_video.vid" :video-poster-src="activeTitle.stem_video.thumb" />
              <el-image
                v-if="activeTitle.title_img"
                :src="activeTitle.title_img"
                class="title_img"
                :preview-src-list="[activeTitle.title_img]"
                style="margin-top: 0;"
              />
            </div>
            <div class="options" :class="$route.query.type?'showDis':''">
              <el-radio-group v-model="activeTitle.value" :disabled="$route.query.type||(examDetailed.answer_rule==2&&activeTitle.value&&activeTitle.nextCheck)?true:false">
                <el-row
                  v-for="(item,i) in activeTitle.option"
                  :key="i"
                  :class="{ selected: activeTitle.value == item.key&&!$route.query.type,selected2: (activeTitle.value == item.key&&activeTitle.is_right==1&&$route.query.type)||(activeTitle.answer===item.key&&$route.query.type),selected3:activeTitle.value == item.key&&activeTitle.is_right==0 &&$route.query.type}"
                >
                  <el-radio :label="item.key">
                    <div class="titls_content">
                      <img v-if="activeTitle.value == item.key&&activeTitle.is_right==1&&$route.query.type" src="@/assets/img/right.png" class="check_img">
                      <img v-if="activeTitle.value == item.key&&activeTitle.is_right==0&&$route.query.type" src="@/assets/img/wrong.png" class="check_img">
                      <span>{{ item.new_key }}.</span>
                      <span class="span" v-html="item.title" />
                    </div>
                    <div>
                      <el-image
                        v-if="item.img"
                        :src="item.img"
                        class="title_img_small"
                        :preview-src-list="[item.img]"
                      />
                    </div>
                  </el-radio>
                </el-row>
              </el-radio-group>
            </div>
          </div>
          <!-- 案例分析 -->
          <div v-else-if="topic.type === 8" class="a3-questions">
            <div v-if="activeTitle.public_number" class="setm" style="margin-bottom:24px">
              <span class="setm-title">主题干：（<span v-if="topic.groupLength>1">{{ getNum }}题共用题干；</span>{{ topic.groupScore }}分）:</span>
              <span class="set-html" v-html="topic.public_title" />
            </div>
            <el-image
              v-if="activeTitle.public_title_img"
              :src="activeTitle.public_title_img"
              class="title_img"
              :preview-src-list="[activeTitle.public_title_img]"
            />
            <div class="setm">
              {{ exams.map(val => val.id).indexOf(activeTitle.id)+1+'、' }}
              <span class="setm-title"><span class="setm-tips">{{ headerType }}</span>（{{ activeTitle.score }}分，可多选）</span>
              <span class="set-html" v-html="activeTitle.title" />
            </div>
            <AudioCompontent v-if="activeTitle.stem_audio" :vid="activeTitle.stem_audio.vid" :auto-play="true" />
            <div style="display: flex;margin-top:12px">
              <VideoComponent v-if="activeTitle.stem_video" :vid="activeTitle.stem_video.vid" :video-poster-src="activeTitle.stem_video.thumb" />
              <el-image
                v-if="activeTitle.title_img"
                :src="activeTitle.title_img"
                class="title_img"
                :preview-src-list="[activeTitle.title_img]"
                style="margin-top: 0;"
              />
            </div>
            <div class="options " :class="$route.query.type?'showDis':''">
              <el-checkbox-group v-model="activeTitle.value">
                <el-row
                  v-for="(item,o) in activeTitle.option"
                  :key="o"
                  :class="{ selected:(activeTitle.value.indexOf(item.key)!== -1)&&!$route.query.type,
                            selected2:(activeTitle.value.indexOf(item.key)!== -1&&$route.query.type)||(activeTitle.answer.split('').indexOf(item.key)!== -1&&$route.query.type),
                            selected3:(activeTitle.value.indexOf(item.key)!== -1&&$route.query.type)&&(activeTitle.answer.split('').indexOf(item.key)== -1&&$route.query.type)
                  }"
                >
                  <el-checkbox :label="item.key" :disabled="$route.query.type||(examDetailed.answer_rule==2&&activeTitle.value&&activeTitle.nextCheck)?true:false">
                    <div class="titls_content">
                      <img v-if="(activeTitle.value.indexOf(item.key)!== -1&&activeTitle.answer.split('').indexOf(item.key)!== -1&&$route.query.type==='review')||($route.query.type==='review'&&activeTitle.answer.split('').indexOf(item.key)!= -1)" src="@/assets/img/right.png" class="check_img">
                      <img v-if="activeTitle.value.indexOf(item.key)!== -1&&activeTitle.answer.split('').indexOf(item.key)== -1&&$route.query.type==='review'" src="@/assets/img/wrong.png" class="check_img">
                      <span>{{ item.new_key }}.</span> <span class="span" v-html="item.title" />
                    </div>
                    <div>
                      <el-image
                        v-if="item.img"
                        :src="item.img"
                        class="title_img_small"
                        :preview-src-list="[item.img]"
                      />
                    </div>
                  </el-checkbox>

                </el-row>
              </el-checkbox-group>
            </div>
          </div>
          <!-- 填空 -->
          <div v-else-if="topic.type === 3" class="fill-questions" />
          <!-- 简答 -->
          <div v-else-if="topic.type === 4" class="short-questions" />
        </div>

        <!-- 解析 -->
        <div v-if="$route.query.type==='review'" class="exam-analysis">
          <div class="anwser">答案：<span class="ml8 righ-anwser">正确答案：{{ activeTitle.answer }}</span><span>你的答案：<span :class="activeTitle.is_right==1?'cor2':'cor1'">{{ activeTitle.answers?activeTitle.answers:'未提交答案' }}</span></span></div>
          <div class="difficulty">难度：<el-rate
            v-model="activeTitle.difficulty"
            class="ml8"
            disabled
            text-color="#ff9900"
          /></div>
          <div class="statistics">统计：<span class="ml8">全部考生答<span>{{ topicStatistics.right+topicStatistics.wrong }}</span>次，对{{ topicStatistics.right }}次，正确率{{ topicStatistics.accuracy }}%，本人答<span class="cor2">{{ topicStatistics.user_right +topicStatistics.user_wrong }}</span>次，对<span class="cor2">{{ topicStatistics.user_right }}</span>次，正确率：<span class="cor2">{{ topicStatistics.user_accuracy }}</span>%。</span></div>
          <div class="outline">大纲：<span class="ml8">{{ outlines?outlines:'暂无大纲' }}</span></div>
          <div v-if="topicVideo.length!=0" class="title-analysis"><span />视频解析</div>
          <div v-if="topicVideo.length!=0" class="vedio-list">
            <video v-for="(item,index) in topicVideo" :key="index" :src="item.playurl" type="video/mp4" controls="controls" class="vedio" />
          </div>
          <div class="title-analysis"><span />考点还原</div>
          <div class="site-restoration" v-html="examPlace" />
          <div class="title-analysis"><span />答案解析</div>
          <div class="anser-key" v-html="anwserPlace" />
        </div>
      </div>
    </div>
    <div class="checK">
      <div class="rule">
        <img v-if="!$route.query.type&&examDetailed.answer_mode!=1" src="@/assets/img/suo.png" class="rule_img">
        <div v-if="!$route.query.type&&examDetailed.answer_mode!=1">
          特殊答题模式已开启，<span class="rule_cor" @click="showRule">查看答题规则 >></span>
        </div>
      </div>
      <div>
        <!-- <span v-if="$route.query.type" class="check_btn analysis" @click="goStatistics(0)">成绩统计</span>
        <span v-if="$route.query.type" class="check_btn analysis" @click="goStatistics(1)">排名统计</span>
        <span v-if="$route.query.type" class="check_btn analysis" @click="goStatistics(2)">章节统计</span> -->
        <span v-if="topic.remarks&&!$route.query.type" class="check_btn mark" @click="checkTips">
          <img src="@/assets/img/tag.png" class="tag">
          已标记</span>
        <span v-else-if="!topic.remarks&&!$route.query.type" class="check_btn mark_dis" @click="checkTips">
          <img src="@/assets/img/tag_dis.png" class="tag">
          标记</span>
        <span v-if="progress.current===1||(examDetailed.answer_rule==1&&examDetailed.answer_mode==2)" class="check_btn prev_dis">上一题</span>
        <span v-else class="prev check_btn" @click="prev">上一题</span>
        <span v-if="progress.current===progress.total" class="check_btn next_dis">最后一题</span>
        <span v-else class="next check_btn" @click="next">下一题</span>

      </div>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      title="预览"
      width="800"
      append-to-body
      @close="()=>{dialogImageUrl=''}"
    >
      <img
        :src="dialogImageUrl"
        style="display: block; max-width: 100%; margin: 0 auto"
      >
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ExamTempalte',
  props: ['exams', 'topic', 'progress', 'tipsIds', 'topicVideo', 'topicStatistics', 'title', 'outlines', 'examDetailed'],
  emits: ['update'],
  data() {
    return {
      list: [],
      dict: {},
      value: '',
      rate: 5,
      typeMap: [{
        id: 1,
        name: '单选题'
      }, {
        id: 2,
        name: '多选题'
      }, {
        id: 8,
        name: '案例分析'
      }, {
        id: 11,
        name: 'A1型题'
      }, {
        id: 12,
        name: 'A2型题'
      }, {
        id: 15,
        name: 'A3/A4型题'
      }, {
        id: 16,
        name: 'B型题'
      }, {
        id: 17,
        name: 'C型题'
      }, {
        id: 18,
        name: 'X题型'
      }, {
        id: 19,
        name: '不定项选择题'
      }, {
        id: 22,
        name: '判断题'
      }
      ],
      dialogVisible: false,
      dialogImageUrl: ''
    }
  },
  computed: {
    getNum() {
      const num = this.exams.map(val => val.public_number).indexOf(this.activeTitle.public_number) + 1
      const name = num + '-' + Number(num + Number(this.activeTitle.groupLength) - 1)
      return name
    },
    headerType() {
      if (this.topic.type) {
        return this.typeMap.find(item => item.id === this.topic.type).name
      } else {
        return ''
      }
    },
    activeTitle() {
      return this.topic
    },
    anwserPlace() {
      if (this.activeTitle.explain) {
        const url = this.activeTitle.explain_img
        const outputString = this.activeTitle.explain_img ? `<img  style='width: 16px;margin-right: 6px;' src='${require('@/assets/img/img.png')}' onclick='deleteFun(${JSON.stringify(url)})'></img>${this.activeTitle.explain}` : this.activeTitle.explain
        var result = outputString.replace(/（[a-zA-Z]+[对错]{1}((?!）).)*）|\([a-zA-Z]+[对错]{1}((?!\)).)*\)/g, function(match) {
          return '<span style="font-weight:bold">' + match + '</span>';
        });
        return result
      } else {
        return `<span>暂无答案解析</span>`
      }
    },
    examPlace() {
      if (this.activeTitle.restore) {
        var that = this;
        const index = 1;
        var result = null
        var outputString = null
        if (this.activeTitle.hospital_id == 1 && this.activeTitle.restore_img) { // 自建
          // const url = that.activeTitle.restore_img
          // const imgShow = `<img  style='width: 16px;margin-right: 6px;' src='${require('@/assets/img/img.png')}' onclick='deleteFun(${JSON.stringify(url)})'></img>`
          outputString = that.activeTitle.restore.replace(/（((?!）).)*P[0-9]+((?!）).)*）|\(((?!\)).)*P[0-9]+((?!\)).)*\)/g, function(match) {
            return `<span style="color:#DD594A;"> ${match}</span>`;
          });
          // result = imgShow + outputString.replace(/（[a-zA-Z]+[对错]{1}((?!）).)*）|\([a-zA-Z]+[对错]{1}((?!\)).)*\)/g, function(match) {
          result = outputString.replace(/（[a-zA-Z]+[对错]{1}((?!）).)*）|\([a-zA-Z]+[对错]{1}((?!\)).)*\)/g, function(match) {
            return '<span style="font-weight:bold">' + match + '</span>';
          });
        } else {
          outputString = this.activeTitle.restore.replace(/（((?!）).)*P[0-9]+((?!）).)*）|\(((?!\)).)*P[0-9]+((?!\)).)*\)/g, function(match) {
            // const ma = match.replace(/[（）]/g, '').replace(/[())]/g, '')
            // const url = `https://ykb-app-files.yikaobang.com.cn/question/restore/${that.activeTitle.app_id}/${that.activeTitle.number}${ma}-${index}.jpg?x-oss-process=style/water_mark`
            // const imgShow = `<img  style='width: 16px;margin-right: 6px;' src='${require('@/assets/img/img.png')}' onclick='deleteFun(${JSON.stringify(url)})'></img>`
            // index++;
            return `<span style="color:#DD594A;"> ${match}</span>`;
            // return `<span style="color:#DD594A;"> ${match}</span>${imgShow}`;
          });
          result = outputString.replace(/（[a-zA-Z]+[对错]{1}((?!）).)*）|\([a-zA-Z]+[对错]{1}((?!\)).)*\)/g, function(match) {
            return '<span style="font-weight:bold">' + match + '</span>';
          });
        }
        return result
      } else {
        return `<span>暂无考点还原</span>`
      }
    }
  },
  watch: {
    topic() {
      this.value = ''
    }
  },
  mounted() {
    window.deleteFun = this.deleteFun
  },
  methods: {
    showRule() {
      this.$emit('showRule')
    },
    deleteFun(data) {
      this.dialogImageUrl = data
      this.dialogVisible = true;
    },
    prev() {
      // const value = this.value?[this.value]:[]
      // const value = this.activeTitle.value ? this.activeTitle.value : []
      if (this.$route.query.type) {
        this.$emit('prevupdata', {
          id: this.topic.id,
          index: this.progress.current
          // value: value
        })
      } else {
        if (this.examDetailed.answer_mode == 1  && (this.topic.type == 2 || this.topic.type == 18)) {
          if (!this.hasData(this.activeTitle.value)) {
            return this.$message.error(`请先对当前题目(${this.progress.current}题)进行作答`)
          }
          if (this.activeTitle.value.length < 2) {
            return this.$message.error('至少选择2个答案')
          }
        }

        // if(((this.topic.type==8||this.topic.type==15)&&this.examDetailed.answer_mode==3&&!(this.examDetailed.subtopic_answer_rule==1&&this.examDetailed.subtopic_prohibit_rollback==2)&&!(this.examDetailed.answer_rule==2&&this.examDetailed.subtopic_answer_rule==2&&this.examDetailed.subtopic_prohibit_rollback==2))){
        if (((this.topic.type == 8 || this.topic.type == 15) && this.examDetailed.answer_mode == 3 && !(this.examDetailed.answer_rule == 1 && this.examDetailed.subtopic_answer_rule == 2 && this.examDetailed.subtopic_prohibit_rollback == 2) && !(this.examDetailed.answer_rule == 1 && this.examDetailed.subtopic_answer_rule == 2 && this.examDetailed.subtopic_prohibit_rollback == 1) && !(this.examDetailed.subtopic_answer_rule == 1 && this.examDetailed.subtopic_prohibit_rollback == 2) && !(this.examDetailed.answer_rule == 2 && this.examDetailed.subtopic_answer_rule == 2 && this.examDetailed.subtopic_prohibit_rollback == 2))) {
          if (!this.hasData(this.activeTitle.value)) {
            return this.$message.error(`请先对当前题目(${this.progress.current}题)进行作答`)
          }
          console.log('进来了，上一题---------')
        }
        this.$emit('prevupdata', {
          id: this.topic.id,
          index: this.progress.current
          // value: value
        })
      }
    },
    next() {
      // localStorage.setItem('examId', this.$store.state.examDetailed.id)
      // const value = this.activeTitle.value ? this.activeTitle.value : []
      if (this.$route.query.type) {
        this.$emit('nextupdate', {
          id: this.topic.id,
          index: this.progress.current
          // value: value
        })
      } else {
        if (this.examDetailed.answer_mode == 1) {
          if (this.topic.type == 2 || this.topic.type == 18) {
            if (!this.hasData(this.activeTitle.value)) {
              return this.$message.error(`请先对当前题目(${this.progress.current}题)进行作答`)
            }
            if (this.activeTitle.value.length < 2) {
              return this.$message.error('至少选择2个答案')
            }
          }
          this.$emit('nextupdate', {
            id: this.topic.id,
            index: this.progress.current
            // value: value
          })
        }
        if (this.examDetailed.answer_mode == 2 || (this.examDetailed.answer_mode == 3 && (this.topic.type == 8 || this.topic.type == 15) && !(this.examDetailed.answer_rule == 1 && this.examDetailed.subtopic_answer_rule == 2 && this.examDetailed.subtopic_prohibit_rollback == 1) && !(this.examDetailed.answer_rule == 2 && this.examDetailed.subtopic_answer_rule == 2))) {
          if (this.hasData(this.activeTitle.value)) {
            if (this.examDetailed.answer_mode == 2 && (this.topic.type == 2 || this.topic.type == 18)) {
              if (this.activeTitle.value.length < 2) {
                return this.$message.error('至少选择2个答案')
              }
            }
            this.$emit('nextupdate', {
              id: this.topic.id,
              index: this.progress.current
              // value: value
            })
          } else {
            return this.$message.error(`请先对当前题目(${this.progress.current}题)进行作答`)
          }
        }
        this.$emit('nextupdate', {
          id: this.topic.id,
          index: this.progress.current
          // value: value
        })
      }
    },
    hasData(value) {
      if (typeof value === 'string') {
        return value.length > 0;
      } else if (Array.isArray(value)) {
        return value.length > 0;
      } else {
        return false;
      }
    },
    checkTips() {
      this.$emit('checkTips')
    },
    goStatistics(type) {
      this.$emit('goStatistics', String(type))
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep{
  .el-radio__label{
    color: #303030;
    white-space: pre-wrap;
    width: 100% !important;
  }
  .el-checkbox__label{
    width: 100% !important;
  }
  .el-radio__input.is-checked+.el-radio__label {
    color: #303030;
  }
  .el-radio__input.is-checked .el-radio__inner {
      background-color: #D9D9D9;
      border: solid 1px #D9D9D9;
  }
  .el-checkbox__input.is-checked + .el-checkbox__label{
      color: #303030;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
      background-color: #D9D9D9;
      border: solid 1px #D9D9D9;
  }
  .showDis .el-radio__inner{
    display: none;
  }
  .showDis .el-checkbox__input{
    display: none;
  }
}
.exam-tempalte-app {
    position: relative;
    height: 100%;
    // overflow-y: scroll;

}
.exam-tempalte-scorll{
  height:calc( 100% - 65px);
  overflow-y: auto;
}
.header-title{
    font-size: 18px;
    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
    font-weight: 700;
    color: #303030;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    background: linear-gradient( 90deg, #FFFBFB 0%, #FFFEFD 100%);
    border-radius: 0px 0px 0px 0px;
    padding: 16px 0;
    margin-left: -24px;
    .bor{
      display: inline-block;
      width: 4px;
      height: 18px;
      margin-right: 8px;
      background-color: #DD594A;
    }
}
.exam-tempalte-header {
    // height: 56px;
    padding-bottom: 16px;
    border-bottom: solid 1px #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.header-type {
    font-size: 16px;
    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
    font-weight: bold;
    color: #303030;
}

.header-type span {
    margin-left: 5px;
}

.header-number {
    font-size: 16px;
    color: #909090;
}

.header-number span {
    color: #DD594A;
}

.options {
    margin-top: 24px;
    font-size: 14px;
}
.titls_content{
  // white-space: pre-wrap;
  // line-height: 15px;
  // display: flex;
  // align-items: center;
  line-height: 15px;
  display: flex;
  .span{
    word-wrap: break-word;
    width: 90%;
    display: inline-block;
  }
}
.check_img{
  width: 16px;
  height: 16px;
  margin-right: 8px;
}
.exam-tempalte-content {
    padding-top: 24px;
}
.exam-analysis{
  font-size: 14px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #303030;
  margin-top: 40px;
  .cor1{
    color: #DD594A;
  }
  .cor2{
    color: #71AC34;
  }
  .ml8{
    margin-left: 8px;
  }
  .anwser{
    .righ-anwser{
      margin-right: 16px;
    }
  }
  .difficulty{
    display: flex;
    align-items: center;
    margin-top: 12px;
  }
  .statistics,.outline{
    margin-top: 12px;
  }
  .title-analysis{
    font-size: 16px;
    font-family: Source Han Sans SC-Medium, Source Han Sans SC;
    font-weight: 500;
    color: #303030;
    margin-top: 40px;
    display: flex;
    align-items: center;
    line-height: 1;
    span{
      width: 3px;
      height: 14px;
      background: #DD594A;
      display: inline-block;
      margin-right: 7px;
    }
  }
  .vedio-list{
    margin-top: 12px;
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 40px;
    border-bottom: 1px solid #EEEEEE;
    .vedio{
      margin-right: 16px;
      width: 250px;
    }
  }
  .site-restoration,.anser-key{
    margin-top: 12px;
    line-height: 28px;
  }
  .img{
    width: 16px;
    margin-right: 6px;
  }
}
.tips {
    width: 72px;
    height: 24px;
    background: #F7F8FA;
    border: solid 1px #eee;
    text-align: center;
    color: #FF8712;
    font-size: 14px;
    line-height: 24px;
    position: absolute;
    left: 0;
    top: 0px;
    text-indent: 0px;
    cursor: pointer;
}

.tips img {
    vertical-align: middle;
}

.setm {
    text-align: left;
    position: relative;
    line-height: 26px;
    font-size: 16px;
    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
    color: #303030;
    font-weight: bold;
    word-wrap: break-word;
}
.title_img{
  width: 160px;
  margin-top: 8px;
  height: 90px;
  border-radius: 12px;
}
.title_img_small{
  width: 114px;
  margin-top: 8px;
  height: 64px;
  border-radius: 4px;
}
.el-radio-group {
    width: 100%;
}

.el-row {
    width: 100%;
    display: flex;
    justify-content: left;
    align-items: center;
    border: solid 1px #eee;
    border-radius: 4px;
    padding-left: 15px;
    margin-bottom: 20px;

    .el-radio,.el-checkbox{
      width: 100%;
      height: 100%;
      padding: 16px 0;
      display: flex;
      // flex-wrap: wrap;
      align-items: center
      // line-height: 46px;
    }

}
.el-rows{
  padding: 16px;
}
.max-tips {
    background-color: #FF8712;
    width: 72px;
    height: 24px;
    text-align: center;
    color: #fff;
    border-radius: 4px;
    border: 1px solid #FF8712;
    font-size: 14px;
}

.max-tips img {
    vertical-align: sub;
}

.checK {
    position: absolute;
    bottom: 0;
    right:24px;
    left: 24px;
    width: calc(100% - 48px);
    height: 56px;
    // text-align: right;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
}
.rule{
    font-size: 14px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #303030;
    display: flex;
    align-items: center;
    .rule_img{
      width: 20px;
      height: 20px;
      margin-right: 6px;
    }
  .rule_cor{
    margin-left: 4px !important;
    color: #DD594A !important;
    cursor: pointer;
  }
}
.check_btn{
  cursor: pointer;
  display: inline-block;
  width: 88px;
  height: 32px;
  border-radius: 3px 3px 3px 3px;
  opacity: 1;
  border: 1px solid #DD594A;
  line-height: 32px;
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  text-align: center;
  margin-left: 16px;
  background-color: #fff;
}
.tag{
  width: 14px;
}
.analysis{
  border: 1px solid #EEEEEE;
}
.mark{
  border: 1px solid #EEEEEE;
  color: #F58D41;
  background: #F7F8FA;
}
.mark_dis{
  background: #F7F8FA;
  color: #909090;
  border: 1px solid #EEEEEE;
}
.prev_dis{
  border: 1px solid #EEEEEE;
  color: #BFBFBF;
}
.next_dis{
  border: 1px solid #EEEEEE;
  color: #BFBFBF;
}
.prev {
    border: 1px solid #DD594A;
    color: #DD594A;
}

.next {
    background-color: #DD594A;
    color: #fff;
    border: solid 1px #DD594A;
}

.selected {
    // border: 1px solid #DD594A;
    background: #EEEEEE;
}
.selected2 {
  background: #F2FFFA;
  border: 1px solid #5FCA71;
  color: #5FCA71;
}
.selected3 {
  background: #FFF4F2;
  border: 1px solid #EB5C55;
  color: #EB5C55;
}
.setm-title{
  color: #DD594A;
}
.setm-tips{
    font-size: 14px;
    padding: 2px 10px;
    background: #FFF1EF;
    border-radius: 4px 4px 4px 4px;
  }
</style>
